<template>
    <div
        class="rcornersgrey mx-auto vstack"
        style="width: 500px; overflow: initial">
        <h1 class="text-center">{{ title }}</h1>
        <h2
            class="text-center"
            v-if="!showNav">
            {{ subTitle }}
        </h2>
        <nav
            class="nav nav-tabs nav-justified"
            v-if="showNav">
            <a
                class="nav-link"
                :class="{active: currentMode == mode.type, 'd-none': modes.length == 1}"
                aria-current="page"
                v-for="mode in modes"
                @click.prevent="handleNavChange(mode.type)"
                >{{ mode.label }}</a
            >
        </nav>
        <div
            :class="{'border-top': !showNav}"
            class="border-start border-end border-bottom p-3">
            <div class="mt-3">
                <label class="form-label mb-1 fw-bolder">Agency:</label>
                <SelectField
                    v-model="selectedOri"
                    :select-items="agencies"
                    :is-horizontal="false"
                    :is-required="true"
                    :ref="
                        (el) => {
                            addValidatableComponent(el);
                        }
                    ">
                </SelectField>
            </div>
            <div v-for="mode in modes">
                <div v-show="currentMode == mode.type">
                    <slot
                        :name="`extra-fields-${mode.type}`"
                        :ref="
                            (el) => {
                                addValidatableComponent(el);
                            }
                        "></slot>
                </div>
            </div>
            <div
                class="alert alert-danger mt-1"
                role="alert"
                v-show="errorText != ''">
                {{ errorText }}
            </div>
            <div class="actions w-100 mt-3 text-center hstack gap-2">
                <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="handleSubmitClick()">
                    Submit
                </button>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import {computed, ref, watch} from "vue";
import {useOriStore} from "@/stores/oriStore";
import useValidation from "../Misc/validationUtils";
import SelectField from "../Misc/SelectField.vue";
import {SelectEntryType, SelectItem, SelectorMode} from "../../types";

const props = defineProps<{
    title: string;
    modes: SelectorMode[];
    showNav: boolean;
    error: string;
    agencies: SelectItem[];
}>();
var oriStore = useOriStore();
const emits = defineEmits(["oriChange", "submit", "modeChange"]);
const {validatableComponentArray, triggerValidation, addValidatableComponent, resetValidatableComponentArray} =
    useValidation();

const selectedOri = ref("");
const errorText = ref("");

if (props.error != "") {
    errorText.value = props.error;
}

const currentMode = ref(SelectEntryType.Add);
if (props.modes.length == 1) {
    currentMode.value = props.modes[0].type;
} else {
    props.modes.forEach((mode) => {
        if (mode?.isDefaultSelection) {
            currentMode.value = mode.type;
        }
    });
}
emits("modeChange", currentMode.value);

const subTitle = computed(() => {
    let subTitle = "";

    switch (currentMode.value) {
        case SelectEntryType.Add:
            subTitle = "Add";
            break;
        case SelectEntryType.Edit:
            subTitle = "Edit";
            break;
        case SelectEntryType.Delete:
            subTitle = "Delete";
            break;
        case SelectEntryType.Zero:
            subTitle = "Zero Report";
            break;
    }

    return subTitle;
});

function handleSubmitClick() {
    if (validate()) {
        emits("submit", selectedOri, currentMode.value);
    }
}

function handleNavChange(newMode: SelectEntryType) {
    currentMode.value = newMode;
    errorText.value = "";
    emits("modeChange", currentMode.value);
}

function validate(): boolean {
    let formValid = false;
    let form = document.getElementById("mainForm") as HTMLFormElement;

    if (form != null) {
        formValid = triggerValidation();

        if (formValid && form.classList.contains("was-validated")) {
            form.classList.remove("was-validated");
        }
    }

    return formValid;
}

watch(
    () => selectedOri.value,
    (newSelectedOri) => {
        oriStore.setSelectedOri(newSelectedOri);
        emits("oriChange", newSelectedOri);
    }
);

watch(
    () => props.error,
    (error) => {
        errorText.value = error;
    }
);
</script>
